import React, { Component, useState } from 'react';

import axios from '@app/lib/axios';
import { Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap';
import { InputGroup, FormControl } from 'react-bootstrap'
import DatePicker from "react-datepicker";
import moment from "moment";

import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import * as Constant from '@app/Constant.js';

import RouteTitle from '@app/components/RouteTitle';
import SystemMessageSearchConfig from "./Components/SystemMessageSearchConfig"
import SystemMessageTable from "./Components/SystemMessageTable"

import "@app/css/datepicker_common.css";
import "./search.css";

class SearchSystemMessage extends Component {
    constructor(props) {
        const userType = localStorage.getItem("login_user_type") || "admin";
        const branchId = userType === "branch" ? localStorage.getItem("login_branch_id") || 0 : 0;
        super(props);
        this.state = {
            branchId: branchId,
            branches: null,
            messages: null,
            searchStartDate: null,
            searchEndDate: null,
            isGridReady: false,
            showLoading: false,
        };
    }

    componentDidMount() {
    }

    getBranchList = (callback) => {
        axios({
            method: "get",
            url: "/api/branch/list/YN"
        })
            .then(result => {
                if (result.data.code === 200) {
                    //console.debug(result.data)
                    var sortedBranches = result.data.branches == null ? null : result.data.branches.sort(function(a, b){
                        if(a.name < b.name) { return -1; }
                        if(a.name > b.name) { return 1; }
                        if(a.use_yn > b.use_yn) { return -1; }
                        if(a.use_yn < b.use_yn) { return 1; }
                        return 0;
                    })
                    this.setState({branches: sortedBranches}, () => {
                        this.onSearchHandler(this.state.searchStartDate, this.state.searchEndDate)
                    })
                } else {
                    console.log(result);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch(error => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }

    onSearchHandler = (startDate, endDate) => {
        if(startDate === null || endDate === null) {
            this.setState({showLoading: false})
            return
        }
        if(this.state.isGridReady) {
            this.setState({showLoading: true}, () => {
                axios({
                    method: "get",
                    url: "/api/search/system_message/" + this.state.branchId + "/" + startDate + "/" + endDate
                })
                    .then(result => {
                        if (result.data.code === 200) {
                            this.setState({messages: result.data.lists, searchStartDate: startDate, searchEndDate: endDate}, () => {
                            })
                        } else {
                            console.log(result);
                            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    });
            })
        }
    }

    onGridReadyHandler = () => {
        this.setState({isGridReady: true}, () => {
            this.getBranchList();
        });
    }

    render() {
        return (
            <div className="dashboard-wrapper">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
					<RouteTitle title="조회 - 시스템 메시지"/>
                </div>
                <div className="container-fluid dashboard-content">
                    
                    <SystemMessageSearchConfig 
                        branchId={this.state.branchId}
                        isGridReady={this.state.isGridReady}
                        onSearchHandler={this.onSearchHandler}
                        toast={toast}
                    >
                    </SystemMessageSearchConfig>

                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <SystemMessageTable
                                height={450}
                                branchId={this.state.branchId}
                                branches={this.state.branches}
                                messages={this.state.messages}
                                startDate={this.state.searchStartDate}
                                endDate={this.state.searchEndDate}
                                onGridReadyHandler={this.onGridReadyHandler}
                                showLoading={this.state.showLoading}
                                toast={toast}
                            ></SystemMessageTable>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    autoClose={2000}
                    hideProgressBar={true}
                    transition={Slide}
                />
            </div>
        );
    }
}


export default SearchSystemMessage;